var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('v-card',[_c('address-form',{attrs:{"modo":'crear',"direccion":_vm.direccion},on:{"processAddress":_vm.addAddress}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }